module.exports = __webpack_public_path__ + "img/pipe.75aa5053.svg";